module.exports = __webpack_public_path__ + "dist/assets/img/designobject.772dc29d.svg";